import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20stylish%20woman%20in%20flowing%20dress%2C%20artistic%20portrait%20photography%2C%20soft%20warm%20golden%20hour%20lighting%2C%20dreamy%20atmospheric%20background%20with%20bokeh%2C%20luxury%20lifestyle%20aesthetic%2C%20minimalist%20composition%2C%20warm%20cream%20and%20rose%20tones%2C%20soft%20shadows&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
        alt="美女视频精选合集"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="美女视频精选合集 - 高清美女视频在线观看"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            美女视频精选合集
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            探索海量美女视频精选合集，涵盖时尚穿搭、生活写真、才艺展示等多元内容。
            高清美女视频在线免费观看，每日更新，发现更多精彩美丽瞬间。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shishang-chuanda"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm whitespace-nowrap transition-all duration-200 cursor-pointer"
            >
              立即探索
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full font-medium text-sm whitespace-nowrap transition-all duration-200 backdrop-blur-sm cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}